import { writable, get } from 'svelte/store';
import { api_host, redirect_uri } from '../stores.js';


const { subscribe, set, update } = writable(null);

var auth2;
var googleuser;

gapi.load('auth2', () => {
	auth2 = gapi.auth2.init({
		client_id: '399256611725-dfh9dki53027bkv6ec97lu1r0le2l9eb.apps.googleusercontent.com',
		redirect_uri: redirect_uri,
		scope: 'profile',
		response_type: 'token'
	});

	auth2.isSignedIn.listen(async (loggedIn) => {
		if (loggedIn) {
			const u = auth2.currentUser.get()
			const profile = u.getBasicProfile();
			const { access_token, id_token } = u.getAuthResponse();

			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ access_token: access_token, code: 'google', id_token: id_token })
			};        
			// const jdata = await fetch(get(api_host) + '/auth/social/google/login', requestOptions)
			// .then(res => res.json())
			// .then(data => data)
			// .catch(error => error);

			update(() => ({
				profile: {
					id: profile.getId(),
					name: profile.getName(),
					image: profile.getImageUrl(),
					email: profile.getEmail()
				},
				token: u.getAuthResponse().id_token
			}));
		} else {
			update(() => null)
		}
	})
});

const signin = () => auth2.signIn();
const logout = () => auth2.signOut();

export const google_user = {
	subscribe,
	signin,
	logout
}